import React, { Component } from 'react';

//componentes
import ReportePla from './reporteP'

class Index extends Component {

    render(){
        return(
            <div>
                <ReportePla />
            </div>
        );
    }

}
export default Index;